module.exports = __webpack_public_path__ + "images/emoji/sos.a15d52ceca7d4b6cd9f3.png";